// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"596":"404","646":"EventsMap","736":"ProximitySearch","845":"SingleEvent"}[chunkId] + "." + {"596":"44ee3198","646":"03707c54","736":"e120d069","845":"1fa3e022"}[chunkId] + ".js";
};